"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M21 0H3a3.0034 3.0034 0 0 0-3 3v18a3.0033 3.0033 0 0 0 3 3h18a3.0034 3.0034 0 0 0 3-3V3a3.0035 3.0035 0 0 0-3-3zm-4.512 13.1211-6.8571 3.8572a1.288 1.288 0 0 1-1.2792-.012 1.287 1.287 0 0 1-.6374-1.1092V8.1429a1.2874 1.2874 0 0 1 1.9166-1.1143l6.8571 3.8571a1.2872 1.2872 0 0 1 .4789 1.7703 1.2872 1.2872 0 0 1-.4789.472v-.0069z"
}), 'Video');

exports.default = _default;